import { Navigate } from "react-router-dom";
import React from "react";

const AdminPrivateRoute = ({ children, token, role }) => {
  return token && role && role.toLowerCase() === "admin" ? (
    children
  ) : (
    <Navigate to="/" />
  );
};

export default AdminPrivateRoute;
